import { render, staticRenderFns } from "./ItemSelector.vue?vue&type=template&id=b062787a&"
import script from "./ItemSelector.vue?vue&type=script&lang=js&"
export * from "./ItemSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports